var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHaviLogoExpanded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 60,
    viewBox: "0 0 124 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 60,
    fill: "#0060A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0001 14V24.1053L45.0001 29.1579V19.0526L29.0116 14H29.0001ZM45.0001 40.105L29.0003 35.0525L29.0001 35.0525V35.0524V24.9473L44.9998 29.9998L45.0001 29.9998V29.9999V40.105ZM13 19.8947L29 24.9473L13 30V19.8947ZM13 30L29 35.0526V24.9474L13 30ZM13 40.9473L29 46V35.8947L13 30.8421V40.9473ZM72.6179 20.2566H68.7139V27.71H62.4696V20.2566H58.5657V38.6799H62.4696V31.0354H68.7139V38.6799H72.6179V20.2566ZM81.4116 20.2566H84.3994L91.4105 38.7181H87.3373L86.2119 35.4883H79.5991L78.4737 38.6799H74.3905L74.4403 38.5557L81.4116 20.2566ZM100.961 20.2566H105.035L104.995 20.3713L98.6707 38.6799H95.7527L89.4187 20.2566H93.4621L97.2266 31.9145L100.961 20.2566ZM82.9752 26.009L80.7046 32.268H85.1662L82.9752 26.009ZM111 20.2566H107.096V38.6799H111V20.2566Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaviLogoExpanded);
export default __webpack_public_path__ + "static/media/havi_logo_expanded.7a8a56b371dade0896f1455fde2a7a71.svg";
export { ForwardRef as ReactComponent };